<script>
import { required, email } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { fieldValidationsMixin } from '@/mixins/fieldValidationsMixin'
export default {
  mixins: [validationMixin, fieldValidationsMixin],
  props: {
    value: {
      type: Object
    },
    show: { type: Boolean },
    loading: {
      type: Boolean
    }
  },
  validations: {
    value: {
      firstName: { required },
      lastName: { required },
      address: { required },
      zipCode: {
        required,
        onlyDigits(val) {
          const reg = /^\d+$/
          return reg.test(val)
        },
        correctLength(val) {
          if (val === null) return false
          return val.length === 5
        }
      },
      city: { required },
      email: { email, required }
    }
  },
  data() {
    return {

    }
  },
  methods: {
    onClick() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$emit('onSubmit')
      }
    }
  }
}
</script>
<template>
  <v-dialog
    :value="show"
    max-width="500"
    :fullscreen="$vuetify.breakpoint.mdAndDown"
    :persistent="!value">
    <v-card>
      <DialogBaseColoredTitle
      ><dialogBaseCloseIcon
        v-if="!loading && value.filled"
        color="white"
        @click="$emit('onClose')"
      />{{ $t('component.testletter.testletterForm.header') }}</DialogBaseColoredTitle>
      <v-divider></v-divider>
      <DialogBaseText>
        <v-row>
          <v-col cols="12" class="text-center">
            <p>{{ $t('component.testletter.testletterForm.subtitle') }}</p>
          </v-col>
          <v-col cols="12" lg="6" md="6" sm="12" class="pt-0 pb-0">
            <v-text-field
              v-model="value.company"
              :label="$t('component.testletter.testletterForm.company')"
              outlined
              dense
              color="green"
              class="primary--text">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pt-0 pb-0" sm="6">
            <v-text-field
              v-model="value.firstName"
              :label="$t('component.testletter.testletterForm.first.name')"
              :error-messages="[...fieldNeccessary($v.value.firstName, $v)]"
              required
              outlined
              dense
              color="primary"
              @input="$v.value.firstName.$touch()"
              @blur="$v.value.firstName.$touch()"
            ></v-text-field
            ></v-col>
          <v-col cols="12" class="pt-0 pb-0" sm="6">
            <v-text-field
              v-model="value.lastName"
              :label="$t('component.testletter.testletterForm.last.name')"
              :error-messages="[...fieldNeccessary($v.value.lastName, $v)]"
              required
              outlined
              dense
              color="primary"
              @input="$v.value.lastName.$touch()"
              @blur="$v.value.lastName.$touch()"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pt-0 pb-0">
            <v-text-field
              v-model="value.address"
              :label="$t('component.testletter.testletterForm.address')"
              :error-messages="[...fieldNeccessary($v.value.address, $v)]"
              required
              outlined
              dense
              color="primary"
              @input="$v.value.address.$touch()"
              @blur="$v.value.address.$touch()"
            ></v-text-field
            ></v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pt-0 pb-0" sm="6">
            <v-text-field
              v-model="value.zipCode"
              :label="$t('component.testletter.testletterForm.zip.code')"
              :error-messages="[
                ...fieldNeccessary($v.value.zipCode, $v),
                ...zipCodeErrors($v.value.zipCode, $v)
              ]"
              required
              outlined
              dense
              color="primary"
              @input="$v.value.zipCode.$touch()"
              @blur="$v.value.zipCode.$touch()"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="pt-0 pb-0" sm="6">
            <v-text-field
              v-model="value.city"
              :label="$t('component.testletter.testletterForm.city')"
              :error-messages="[...fieldNeccessary($v.value.city, $v)]"
              required
              outlined
              dense
              color="primary"
              @input="$v.value.city.$touch()"
              @blur="$v.value.city.$touch()"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="pt-0 pb-0">
            <v-text-field
              v-model="value.email"
              :label="$t('component.testletter.testletterForm.email')"
              :error-messages="[
                ...fieldNeccessary($v.value.email, $v),
                ...emailInvalid($v.value.email, $v)   ]"
              outlined
              dense
              @input="$v.value.email.$touch()"
              @blur="$v.value.email.$touch()"
            ><v-icon size="20">mdi-information-outline</v-icon></v-text-field>
            <v-checkbox
              v-model="value.newsletter"
              hide-details=""
              :label="$t('component.testletter.testletterForm.checkbox.newsletter.label')"
              class="mt-0" />
          </v-col>
        </v-row>
      </DialogBaseText>
      <v-divider></v-divider>
      <DialogBaseActions>
        <v-btn
          color="secondary"
          :disabled="loading"
          @click="$emit('onCancel')"
        >{{ $t('button.cancel') }}</v-btn>
        <v-spacer />
        <v-btn color="success" :loading="loading" @click="onClick">{{
            $t('button.take.over') }}</v-btn>
      </DialogBaseActions>
    </v-card>
  </v-dialog>
</template>
